var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-option",style:(_vm.dynamicStyle),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.tooltip)?_c('el-tooltip',{staticClass:"group-tooltip",attrs:{"content":_vm.description,"placement":"right"}},[[_vm._t("icon",null,{"_class":'side-option-icon'})]],2):[_vm._t("icon",null,{"_class":'side-option-icon'})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }